import { createFileRoute } from '@tanstack/react-router'
import Publication from '../../../../../components/Publications/Publication'
import NotFound from '../../../../../components/Common/NotFound'

export const Route = createFileRoute('/_layout/d/id/$classicId/t/$title')({
  component: Publication,
  notFoundComponent: NotFound,
})
